import dayjs from 'dayjs';
import { strToNumber } from 'modules/shared/utils';

export const voucherRequestValidation = {
  expenseType: {
    required: 'Please select an expense type',
  },
  amountRequested: {
    required: 'Please enter an amount',
    validate: (value) => {
      if (!value) return true;
      const num = strToNumber(value);
      if (Number.isNaN(Number(num))) return 'Amount must be a number';
      if (Number(num) < 1) return 'Amount cannot be less than ₹1';
      return true;
    },
  },
  dateOfEvent: {
    required: 'Please select a date of event',
    validate: (value) => {
      if (!value) return true;

      const today = dayjs().startOf('day');
      const date = dayjs(value).startOf('day');

      return date.isSame(today) || date.isBefore(today) || 'Event date cannot be in the future';
    },
  },
  employeeNote: {
    required: false,
    minLength: { value: 3, message: 'Note must be at least 3 characters long' },
    maxLength: {
      value: 600,
      message: 'Note cannot be more than 600 characters long',
    },
  },
  attachment: {
    required: false,
  },
};
